import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { unsubscribe } from '../../actions/campaignActions';


function CampaignUnsubscribeComponent({ buttonText, message, unsubscribed,redirectUrl, unsubscribe }) {
  const handleButtonClick = () => {
    // Validate email format
  
    unsubscribe();
    
  };
  
  return (

<div>
      {!unsubscribed ? (
        <button onClick={handleButtonClick}>{buttonText}</button>
      ) : (
        <p>{message}</p>
      )}
    </div>
    
  );
}

const mapStateToProps = (state) => {
  return {
    unsubscribed: state.user.unsubscribed,
    redirectUrl: state.landing.landing.RedirectUrl
  };
};

export default connect(mapStateToProps, { unsubscribe })(CampaignUnsubscribeComponent);